import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { InterestPointService } from '../services/interest-point.service';
import { DeviceService } from '../services/device.service';
import { PositionService } from '../services/position.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-interest-point',
  templateUrl: './interest-point.component.html',
  styleUrls: ['./interest-point.component.css']
})
export class InterestPointComponent implements OnInit {

  msgs: Message[] = [];
  interestPoint: any;
  interestPoints : any [];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;
  types:SelectItem[];
  options: any;
  overlaysAdd: any[];
  overlaysEdit: any[];
  position: any;
  mapAdd: google.maps.Map;
  mapEdit: google.maps.Map;
  markerAdd: google.maps.Marker;
  markerEdit: google.maps.Marker;
  cols: any[];

  constructor(private interestPointService : InterestPointService,private confirmationService: ConfirmationService
    ,private deviceService:DeviceService,private positionService:PositionService,public userService: UserService) { }

  ngOnInit() {
    this.cols = [
            { field: 'idInterestPoint', header: 'ID' },
            { field: 'name', header: 'NOMBRE PDI' },
            { field: 'latLng', header: 'POSICION' },
            { field: 'nickName', header: 'CREADO POR' },
            { field: 'registerTime', header: 'FECHA DE CREACION' },
            { field: 'personal', header: 'TIPO PDI' },
            { field: 'type', header: 'ICONO PDI' }
        ];
    this.options = {
      zoom: 13
    };
    this.init();
    this.types = [];
    this.types.push({label: "Aeropuerto", value: 1});
    this.types.push({label: "Area Verde", value: 2});
    this.types.push({label: "Bar", value: 3});
    this.types.push({label: "Bus", value: 4});
    this.types.push({label: "Cafetería", value: 5});
    this.types.push({label: "Cajero", value: 6});
    this.types.push({label: "Casa", value: 7});
    this.types.push({label: "Centro de llamadas", value: 8});
    this.types.push({label: "Colegio", value: 9});
    this.types.push({label: "Correo", value: 10});
    this.types.push({label: "Favorito", value: 11});
    this.types.push({label: "Gasolinera", value: 12});
    this.types.push({label: "Hospital", value: 13});
    this.types.push({label: "Hotel", value: 14});
    this.types.push({label: "Iglesia", value: 15});
    this.types.push({label: "Lavadero de Autos", value: 16});
    this.types.push({label: "Libreria", value: 17});
    this.types.push({label: "Museo", value: 18});
    this.types.push({label: "Parada de Bus", value: 19});
    this.types.push({label: "Restaurant", value: 20});
    this.types.push({label: "WiFi", value: 21});
    this.types.push({label: "Dormitorio", value: 22});
    this.types.push({label: "Edificio", value: 23});
    this.types.push({label: "Supermercado", value: 24});
    this.types.push({label: "Universidad", value: 25});
    this.types.push({label: "Cliente Bueno", value: 26});
    this.types.push({label: "Cliente Especial", value: 27});
    this.types.push({label: "Cliente Regular", value: 28});
    this.types.push({label: "Corporación", value: 29});
    this.types.push({label: "Empresa", value: 30});
    this.types.push({label: "Proveedor", value: 31});
    this.types.push({label: "Sucursal", value: 32});
    this.types.push({label: "Taller", value: 33});
    this.types.push({label: "Estación Marina", value: 34});
    this.types.push({label: "Estación de Tren", value: 35});
  }

  init(){
    this.overlaysAdd=[];
    this.overlaysEdit=[];
    this.interestPoint = null;

    this.markerAdd = null;
    this.markerEdit = null;
    this.deviceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      /*let indice = -1;
      response.devices.forEach((element,index) => {
        if(element.idPosition){
          indice = index;
        }
      });
      if(response.devices.length > 0){
        this.positionService.getLastPosition(response.devices[0].idDevice).then(data => {
          let response: any = data;
          this.position = response.position;
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        });
      }*/
      if(response.devices.length > 0){
        let device = response.devices.find(device => device.positions != null &&  device.positions.length > 0);
        this.position = device.positions[0];
      }
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });

    this.blockedDocument=true;
    this.interestPoints = [];
    this.interestPointService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.interestPoints.forEach(item => {
        item.latitude = item.latitude.toFixed(6);
        item.longitude = item.longitude.toFixed(6);
        item.latLng = item.latitude+", "+item.longitude
        this.interestPoints.push(item);
      });
      this.blockedDocument=false;
    }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument=false;
    });
    this.interestPoint = {idUser: this.userService.userLoged.idUser,personal:true};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  showAdd(){
    this.displayAdd = true;
  }

  showEdit(interestPoint:any){
    this.overlaysEdit = [];
    this.interestPoint=interestPoint;
    let latLng = new google.maps.LatLng(this.interestPoint.latitude,this.interestPoint.longitude);
    this.markerEdit = new google.maps.Marker({position: latLng,draggable: true});
    this.overlaysEdit.push(this.markerEdit);

    this.displayEdit = true;

    setTimeout(()=> { // map will need some time to load
      if(this.mapEdit!=null){
        this.mapEdit.setCenter(new google.maps.LatLng(this.interestPoint.latitude,this.interestPoint.longitude));
      }
    }, 500);


  }

  hide(){
    this.interestPoint = {idUser: this.userService.userLoged.idUser,personal:true};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  add(){
    this.blockedDocument = true;
    this.interestPoint.latitude = this.markerAdd.getPosition().lat();
    this.interestPoint.longitude = this.markerAdd.getPosition().lng();

    this.interestPointService.create(this.interestPoint).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.interestPoint.latitude = this.markerEdit.getPosition().lat();
    this.interestPoint.longitude = this.markerEdit.getPosition().lng();
    this.interestPointService.edit(this.interestPoint).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.interestPointService.remove(id).then(data =>{
                  let response: any = data;
                    if(response.status == 'OK'){
                      this.init();
                      this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
                    }else{
                      this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err =>{
                    this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
                    this.blockedDocument = false;
                });
            }
        });
  }


  setMapAdd(event) {
    this.mapAdd = event.map;
    this.mapAdd.setCenter(new google.maps.LatLng(this.position.latitude, this.position.longitude));
  }

  setMapEdit(event) {
    this.mapEdit = event.map;
    if(this.interestPoint.latitude !=null && this.interestPoint.longitude !=null){
      this.mapEdit.setCenter(new google.maps.LatLng(this.interestPoint.latitude,this.interestPoint.longitude));
    }

  }

  handleMapClickAdd(event) {
    this.overlaysAdd=[];
    this.markerAdd = new google.maps.Marker({position: event.latLng,draggable: true});
    this.overlaysAdd.push(this.markerAdd);
  }

  handleMapClickEdit(event) {
    this.overlaysEdit=[];
    this.markerEdit = new google.maps.Marker({position: event.latLng,draggable: true});
    this.overlaysEdit.push(this.markerEdit);
  }

  isValidMarker(){
    return this.markerAdd != null;
  }
}



// WEBPACK FOOTER //
// ./src/app/interest-point/interest-point.component.ts